export default __webpack_public_path__ + "static/media/P10005.07968608.png";